import { useEffect, useState } from "react";
import { AlertTriangle } from "lucide-react";
import api from "@/lib/api";

const fmt = (d) => new Date(`${d}T00:00:00`).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
const dayAfter = (d) => { const x = new Date(`${d}T00:00:00`); x.setDate(x.getDate() + 1); return x.toISOString().slice(0, 10); };

// Warns the clinician when a required document expires within 30 days (badge at risk) or has expired.
export default function BadgeRiskBanner({ onUpload }) {
  const [c, setC] = useState(null);
  useEffect(() => { api.get("/pro/compliance").then((r) => setC(r.data)).catch(() => {}); }, []);
  const risk = c?.at_risk || [], gone = c?.expired || [];
  if (!risk.length && !gone.length) return null;
  return (
    <div className={`rounded-xl border px-4 py-3 mb-4 text-[12.5px] ${gone.length ? "bg-rose-50 border-rose-200 text-rose-900" : "bg-amber-50 border-amber-200 text-amber-900"}`} data-testid="pro-badge-risk">
      <div className="flex items-center gap-2 font-semibold text-[13px]">
        <AlertTriangle size={15} /> {gone.length ? "Document expired — renew it to get your Certified badge back" : "Certified badge at risk"}
      </div>
      <ul className="mt-1.5 space-y-0.5">
        {gone.map((r) => <li key={r.doc_type} data-testid={`pro-badge-expired-${r.doc_type}`}><b>{r.label}</b> expired on {fmt(r.expiry)}.</li>)}
        {risk.map((r) => <li key={r.doc_type} data-testid={`pro-badge-risk-${r.doc_type}`}><b>{r.label}</b> expires on {fmt(r.expiry)} — {c.certified ? "you'll lose your Certified badge" : "it stops counting"} on {fmt(dayAfter(r.expiry))}.</li>)}
      </ul>
      <button onClick={onUpload} className="mt-2 font-semibold underline" data-testid="pro-badge-risk-upload">Upload renewed document →</button>
    </div>
  );
}
